@if (form && handleSubmit) {
  <form
    data-qa="op-form--container"
    class="op-form"
    [formGroup]="form"
    (submit)="submitForm(form)"
    >
    <formly-form [form]="form"
      [model]="innerModel"
      [fields]="fields"
      (modelChange)="onModelChange($event)"
      class="op-form--fieldset"
     />
    @if (handleSubmit) {
      <div class="op-form--submit"
        >
        <button type="submit"
          class="button -primary"
          [disabled]="inFlight">
          {{text.save}}
        </button>
        <button type="button"
          class="button"
          (click)="handleCancel()">
          {{text.cancel}}
        </button>
      </div>
    }
  </form>
}

<!-- When used as a FormControl, the Dynamic Form doesn't need a wrapping form -->
<!-- TODO: Issue: sharing the form as an ng-template between this two HTML blocks doesn't work because
the nested OpFormFieldComponent doesn't find the injected FormGroupDirective. --->
@if (form && !handleSubmit) {
  <formly-form data-qa="op-form--container"
    class="op-form--fieldset"
    [form]="form"
    [model]="innerModel"
    [fields]="fields"
    (modelChange)="onModelChange($event)"
   />
}
